<template>
  <layout-with-centered-content v-if="userAccount" class="new-player">
    <div class="new-player-layout">
      <div class="desc help" :class="{open:isHelpOpen}">
        <transition-expand>
          <div v-show="isHelpOpen">
            <div class="diagram px-player-connection">
              <div class="drawing-wrap">
                <img class="px-installation" src="../../../static/img/px-player.png" height="434" width="500"/>
                <div class="download-app">
                  <img class="player-icon" src="../../../static/img/pxflux-player-icon-v5-128px.png">
                  <span class="label app">pxPlayer app</span>
                  <div class="download-arrow"></div>
                </div>
                <span class="label pin" :class="['left', 'right'][i-1]" v-for="i in 2" :key="i">
              <span>PIN</span><br/>123456
            </span>
              </div>
            </div>
            <ul class="steps desc-list text-block">
              <li>
                <span class="number"><span>1</span></span>
                <span>
              <i>On the computer, which is going to be used as an Art Player</i>: <b>Download & Lunch</b> the <b>pxPlayer</b> app.
            </span>
              </li>
              <li>
                <span class="number"><span>2</span></span>
                <span>
                <i>Bellow:</i> <b>Add the 6-digits PIN</b> shown on the player's screen.
            </span>
              </li>
            </ul>
          </div>
        </transition-expand>
      </div>
      <form id="form-player" class="pin-box" @submit.prevent="accept">
        <label for="pin">Player PIN</label>
        <h1>
          <input id="pin" type="text" v-model.trim="pin">
        </h1>
        <button>Connect to Player</button>
        <button class="help"
                :class="{open:isHelpOpen}"
                @click="isHelpOpen=!isHelpOpen">
          <span>?</span>
        </button>
      </form>
    </div>
  </layout-with-centered-content>
</template>

<script>
import { mapState } from 'vuex'
import firebase from '../../firebase-app'
import { log } from '../../helper'
import LayoutWithCenteredContent from '../elements/UI/layouts/LayoutWithCenteredContent'
import TransitionExpand from '../elements/UI/TransitionExpand'

export default {
  components: { LayoutWithCenteredContent, TransitionExpand },
  data () {
    return {
      pin: '',
      isHelpOpen: false
    }
  },
  computed: {
    ...mapState(['userAccount']),

    accountId () {
      if (!this.userAccount) {
        return null
      }
      return this.userAccount['.key']
    }
  },
  methods: {
    accept () {
      if (this.accountId) {
        const account = {
          accountId: this.accountId
        }
        firebase.database().ref('player-pins/' + this.pin).set(account).then(() => {
          this.$router.push('/account/players')
        }).catch(log)
      }
    }
  }
}
</script>
<style lang="scss">
  @import "../../scss/vars";
  @import "../../scss/mixins";

  .new-player {
    .scroll-box {
      width: 100%;
      max-height: calc(100% - #{$basic-size});
      margin-top: $basic-size / 2;
    }
  }
  .new-player-layout {
    padding: 0 $basic-size;
    display: flex;
    flex-flow: column;
    min-height: 0;
    max-height: 100%;
    width: 100%;

    .desc {
      position: relative;
      flex-grow: 1;
      width: 100%;

      &.open {
        position: relative;
        overflow-y: auto;
        padding: $basic-padding;
        border-bottom: 1px dashed $px-color-grey-semi;
      }

      .diagram, .text-block {
        margin: $basic-size auto $basic-padding;
      }
    }

    form {
      flex-shrink: 0;
      flex-grow: 0;
      margin: $basic-padding auto 0;

      label {
        text-align: center;
      }

      &:before {
        $c: $dark-bg;
        content: '';
        display: block;
        height: $basic-padding * 2;
        width: 100vw;
        background: linear-gradient(transparent,$c 50%);
        position: absolute;
        bottom: calc(100% + #{$basic-padding} + 1px);
        left: 50%;
        transform: translateX(-50%);
        pointer-events: none;
      }
    }
    .text-block {
      max-width: 40rem;
    }

    .diagram {
      box-sizing: content-box;
      position: relative;
      width: 100%;
      max-width: 278px;
      height: auto;

      .drawing-wrap {
        position: relative;
        width: 90%;
        margin-top: $basic-padding;
      }

      img.px-installation {
        width: 100%;
        height: auto;
        display: block;
        /*background: rgba(248, 186, 0, 0.71);*/
      }

      .label {
        position: absolute;
        font-size: 12px;
        font-weight: 400;
        line-height: 1.2em;
        text-align: center;

        &.comp {
          bottom: 0;
          right: 0;
          text-align: left;
          width: 30%;
          background: $dark-bg;
        }

        &.pin {
          font-size: 18px;
          font-weight: 500;
          transform: skewY(-29deg) translate(-50%, -50%) scaleX(0.8);
          line-height: 1;
          color: $px-color-grey;
          opacity: 0.5;

          & > span {
            font-size: 10px;
          }

          &.left {
            left: 19%;
            top: 36.5%
          }

          &.right {
            left: 49%;
            top: 17.5%;
          }
        }
      }

      &.px-player-connection {

        .download-app {
          display: flex;
          flex-flow: column;
          align-items: center;

          position: absolute;

          width: 64px;

          top: 47%;
          left: 91%;
          transform: translate(-50%, -100%);

          .player-icon {
            width: 100%;
          }

          .label {
            position: relative;
            margin: 2px 0 6px;
          }

          .download-arrow {
            $color: #000;
            $arr-h: $basic-size /6;
            position: relative;
            top: 100%;
            width: 100%;
            height: $arr-h * 2;

            &:before, &:after {
              content: '';
              position: absolute;
              width: $basic-size/8;
              height: $arr-h;
            }

            &:before {
              background: $color;
              top: 0;
              left: 50%;
              transform: translateX(-50%);
            }

            &:after {
              box-sizing: border-box;
              border: $arr-h solid;
              border-color: $color transparent transparent transparent;
              left: 50%;
              top: 0;
              transform: translate(-50%, $arr-h);
            }
          }
        }
      }
    }

    form.pin-box {
      position: relative;
      min-width: 0;
      display: flex;
      flex-flow: column nowrap;
      align-items: center;
      margin-bottom: $basic-size;

      label {
        display: block;
        font-size: $h2-font-size;
        min-width: unset;
        width: 100%;
        max-width: 15rem;
        text-align: center;
      }

      h1 {
        margin: 0;
      }

      input {
        width: 100%;
        max-width: 15rem;
        text-align: center;
      }

      button {
        background: transparent;
        &.help {
          position: absolute;
          top: $basic-padding;
          right: 100%;
          padding: 0;
          border-radius: 50%;
          border: 1px dashed $px-color-grey-semi;
          background: transparent;
        }
      }
    }
  }

  .desc {
    @include small-text;

    li {
      display: flex;
      align-items: center;
      min-height: unset;
      margin-bottom: $basic-padding;

      .number {
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: center;

        width: $two-thirds;
        height: $two-thirds;
        border-radius: 50%;
        border: 1px solid $px-color-grey;
        margin-right: $basic-padding;

        span {
          line-height: 0;
        }
      }
    }
  }
</style>
